<template>
    <div class="main">
        <c-panel>
            <certificados></certificados>
        </c-panel>
    </div>
</template>
<script>

import certificados from "./certificados"

export default {
    components:{ certificados }
}
</script>
